import React from 'react';
import { Dialog } from 'src/components/PulseUI';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

interface FilterSetWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filterTypes: string[];
}

const FilterSetWarningModal: React.FC<FilterSetWarningModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  filterTypes,
}) => {
  const formatFilterType = (type: string) => {
    return type
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} size="md" className="h-auto">
      <Dialog.Header>
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-amber-100 rounded-full">
            <Icon
              icon={faExclamationTriangle}
              className="w-5 h-5 text-amber-600"
            />
          </div>
          <h2 className="text-lg font-semibold text-slate-800">
            Filter Set Warning
          </h2>
        </div>
      </Dialog.Header>
      <Dialog.Content>
        <div className="p-6">
          <p className="text-slate-700 leading-relaxed">
            The selected filter set contains the following filter types that
            will be ignored for Fresh Faces results:
          </p>
          <ul className="list-disc list-inside text-sm text-slate-700 bg-slate-50 p-3 rounded mt-3">
            {filterTypes.map((type) => (
              <li key={type}>{formatFilterType(type)}</li>
            ))}
          </ul>
          <p className="text-slate-700 leading-relaxed mt-4">
            Other filters on this filter set will still be applied. Do you want
            to continue saving this strategy?
          </p>
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="px-4 py-2 text-sm font-medium text-white bg-sky-600 rounded-lg hover:bg-sky-800 transition-colors"
        >
          Continue & Save
        </button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default FilterSetWarningModal;
